import { APEX_API_URL } from '@/constants';
import { isServerSide } from '@/helpers';
import { INextAuthSessionModel } from '@/interfaces/authentication';
import { IProfile, IProfileAddressModel, IProfileAddressPostModel, IProfileModel, IRewardPoint, IRewardPointTransaction } from '@/interfaces/profile';
import { serverSideAxiosInstance } from '@/utils/serverSideAxiosClientWithInterceptor';
import axiosInstanceFromComponent from '../components/AxiosInterceptorComponent';
import { FeedbackPayload } from '@/pages/feedback';

let axiosInstance = serverSideAxiosInstance;
if (!isServerSide()) {
  axiosInstance = axiosInstanceFromComponent;
}
export const updateProfile = async (item: IProfile): Promise<IProfile> => {
  let body = item;
  const response = await axiosInstance.put(`${APEX_API_URL}/api/profile`, body);
  return response.data;
};
export const getProfile = async (accessToken?: string | null): Promise<IProfileModel> => {
  const response = await axiosInstance.get(`${APEX_API_URL}/api/profile`, {
    headers: {
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data;
};
export const getProfileAddressList = async (session?: INextAuthSessionModel | null): Promise<IProfileAddressModel[]> => {
  const response = await axiosInstance.get(`${APEX_API_URL}/api/profile/address/list`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  });
  return response.data;
};
export const updateProfileAddress = async (item: IProfileAddressPostModel): Promise<IProfileAddressPostModel> => {
  let body = item;
  const response = await axiosInstance.post(`${APEX_API_URL}/api/profile/address`, body);
  return response.data;
};
export const deleteProfileAddress = async (addressId: string, customerId: string): Promise<any> => {
  let body = {
    customerId,
    addressId,
  };
  const response = await axiosInstance.delete(`${APEX_API_URL}/api/profile/address`, { data: body });
  return response.data;
};
export const getRewardPoint = async (session?: INextAuthSessionModel | null): Promise<IRewardPoint> => {
  const response = await axiosInstance.get(`${APEX_API_URL}/api/profile/reward-points`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  });
  return response.data;
};
export const getRewardPointsTransaction = async (
  pageSize: number,
  pageNumber: number,
  session?: INextAuthSessionModel | null,
  showPurchaseOnly?: boolean,
): Promise<IRewardPointTransaction> => {
  const response = await axiosInstance.get(`${APEX_API_URL}/api/profile/reward-points/transactions`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
    params: {
      pageSize,
      pageNumber,
      showPurchaseOnly,
    },
  });
  return response.data;
};

export const deleteProfile = async (accessToken?: string | null): Promise<any> => {
  const response = await axiosInstance.delete(`${APEX_API_URL}/api/profile`, {
    headers: {
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data;
};

export const postFeedback = async (item: FormData): Promise<any> => {
  let body = item;
  const response = await axiosInstance.post(`${APEX_API_URL}/api/ticket`, body);
  return response.data;
};
